import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MdInfoOutline } from "react-icons/md";
import moment from 'moment';

import { Editor } from 'primereact/editor';
import { toast } from "react-toastify";
import { Button, Col, Form, OverlayTrigger, Row, Spinner, Tooltip } from "react-bootstrap";

import { getPrivacyPolitics, updatePrivacyPolitics } from "../../../../../services/manager/admin/settings.service";
import { ICommonComponent } from "../models/commonComponent";

export const Privacy: React.FC<ICommonComponent> = ({ isLoading = true}) => {
  const { t: translation } = useTranslation();

  const [privacy, setPrivacy] = useState("");
  const [updateTime, setUpdateTime] = useState(0);
  const [loading, setLoading] = useState<boolean>(true);
  const [loadingButton, setLoadingButton] = useState<boolean>(false);
  const [haveChanges, setHaveChanges] = useState(false);
  const [isPublished, setIsPublished] = useState(false);
  const [isRequiredInRegister, setIsRequiredInRegister] = useState(false);

  const handleChangePrivacy = (e: any) => {
    setPrivacy(e.htmlValue)
    setHaveChanges(true)
  }

  const handleUpdatePrivacy = () => {
    setLoadingButton(true)

    let obj = {
      body: privacy,
      is_public: isPublished,
      is_required: isRequiredInRegister
    }

    updatePrivacyPolitics(obj).then(() => {
      toast.success("Políticas de privacidade atualizadas com sucesso!")
      setLoadingButton(false)
      setHaveChanges(false)
    }).catch(() => {
      toast.error("Ocorreu um erro ao atualizar as políticas de privacidade. Tente novamente.")
      setLoadingButton(false)
      setHaveChanges(false)
    })
  }

  useEffect(() => {
    getPrivacyPolitics().then((resp: any) => {
      setIsPublished(resp.is_public)
      setIsRequiredInRegister(resp.is_required)
      setPrivacy(resp.body ?? "")
      const daysDiff = moment(resp.updated_at).add(1, 'seconds').diff(new Date(), 'days');
      setUpdateTime(daysDiff)
    }).finally(() => {
      setLoading(false)
    })
  }, [])

  if (loading && isLoading) {
    return (
      <div className="loading-container">
        <Spinner animation="border" variant="primary" />
      </div>
    )
  }

  return (
    <Row className="ml-2 mt-3 mr-4">
      <h5 className="text-black mb-4"><b>{translation('manager.settings.privacy')}</b></h5>
      <Col md={6}>
        <p className="font-light text-darker-grey">Configure abaixo as políticas de privacidade da DStore.</p>
      </Col>
      <Col md={6} className="d-flex justify-content-end">
        <p className="mb-0 mr-2 font-light text-darker-grey">{isPublished ? "Despublicar" : "Publicar"}</p>
        <Form.Check
          type="switch"
          checked={isPublished}
          onChange={() => {
            setIsPublished(!isPublished)
            setHaveChanges(true)
          }}
        />
      </Col>

      <Col xs={12} className="mt-5 mb-4">
        <Editor style={{ height: '300px' }} value={privacy} onTextChange={(e) => handleChangePrivacy(e)}/>
        <p className="mb-0 mt-2 mr-2 font-12 font-light text-dark-grey">
          Atualizado 
          {
            updateTime > 0 ? (
              <>
                {
                  updateTime === 1 ? (
                    " há " + updateTime + " dia"
                  ) : (
                    " há " + updateTime + " dias"
                  )
                }
              </>
            ) : (
              " hoje"
            )
          }
        </p>
      </Col>

      <Col md={6} className="d-flex text-darker-grey mb-4">
        <OverlayTrigger
          placement={'top'}
          overlay={<Tooltip>Ao ativar essa opção o usuário deverá aceitar os termos de serviço e a política de privacidade para efetuar o cadastro na dstore.</Tooltip>}
        >
          <span>
            <MdInfoOutline size="20" className="mb-1"/>
          </span>
        </OverlayTrigger>

        <p className="mb-0 ml-2 mr-2 font-light">Obrigar aceite no cadastro</p>
        <Form.Check
          type="switch"
          checked={isRequiredInRegister}
          onChange={() => {
            setIsRequiredInRegister(!isRequiredInRegister)
            setHaveChanges(true)
          }}
        />
      </Col>
      <Col md={6} className="d-flex justify-content-end mb-4">
        {
          haveChanges &&
          <>
            {
              loadingButton ? (
                <Spinner animation="border" variant="primary" style={{ width: '2rem', height: '2rem', borderWidth: '0.25em', borderRightColor: 'transparent' }} />
              ) : (
                <Button onClick={() => handleUpdatePrivacy()}>{translation('manager.settings.save')}</Button>
              )
            }
          </>
        }
      </Col>
    </Row>
  )
}